import React, { useState, useEffect } from 'react';
import { useNavigation } from './NavigationProvider';
import Icon from '../AppIcon';

const navigationItems = [
  {
    label: 'Dashboard',
    path: '/financial-dashboard',
    icon: 'LayoutDashboard',
    tooltip: 'View your financial overview'
  },
  {
    label: 'Retirement',
    path: '/retirement-planning-setup',
    icon: 'PiggyBank',
    tooltip: 'Plan your retirement goals'
  },
  {
    label: 'Life Goals',
    path: '/life-goals-management',
    icon: 'Target',
    tooltip: 'Manage your life objectives'
  },
  {
    label: 'Account',
    path: '/user-registration',
    icon: 'User',
    tooltip: 'Manage your profile'
  }
];

export const PrimaryNavigation = () => {
  const { activeItem, handleNavigate } = useNavigation();
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleItemClick = (path) => {
    handleNavigate(path);
  };

  if (isMobile) {
    return (
      <nav className="primary-navigation primary-navigation-mobile" role="navigation" aria-label="Primary navigation">
        <div className="mobile-nav-items">
          {navigationItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleItemClick(item?.path)}
              className={`mobile-nav-item ${activeItem === item?.path ? 'active' : ''}`}
              aria-label={item?.tooltip}
              aria-current={activeItem === item?.path ? 'page' : undefined}
            >
              <Icon name={item?.icon} size={24} />
              <span className="mobile-nav-label">{item?.label}</span>
            </button>
          ))}
        </div>
      </nav>
    );
  }

  return (
    <nav className="primary-navigation primary-navigation-desktop" role="navigation" aria-label="Primary navigation">
      <div className="primary-navigation-container">
        <div className="brand-header">
          <div className="brand-logo-container">
            <Icon name="TrendingUp" size={24} className="brand-logo" />
          </div>
          <span className="brand-text">Fire by Dexterr</span>
        </div>
        
        <div className="primary-navigation-items">
          {navigationItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleItemClick(item?.path)}
              className={`primary-navigation-item ${activeItem === item?.path ? 'active' : ''}`}
              aria-label={item?.tooltip}
              aria-current={activeItem === item?.path ? 'page' : undefined}
            >
              <Icon name={item?.icon} size={20} />
              <span>{item?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};